import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  animate404: boolean = false;
  message: string;

  constructor(
    private route: ActivatedRoute
  ) {
    this.message = route.snapshot.params['message'];
  }

  ngOnInit() {
    //this.message = "test error message";
    setTimeout(() => {this.animate404 = true;},1000);
  }


}
